export default {
  foundByEmail: 'FOUND_BY_EMAIL',
  foundByEmailButNotByPhone: 'FOUND_BY_EMAIL_BUT_NOT_BY_PHONE',
  foundByPhoneAndEmail: 'FOUND_BY_PHONE_AND_EMAIL',
  foundByEmailAndAlsoByPhone: 'FOUND_BY_EMAIL_AND_ALSO_BY_PHONE',
  foundInContacts: 'FOUND_IN_CONTACTS',
  foundInUsers: 'FOUND_IN_USERS',
  notFound: 'NOT_FOUND',
};
